import { PaginationLink as _PaginationLink, PaginationLinkProps as _PaginationLinkProps } from "reactstrap";

    export const PaginationLink = _PaginationLink;
    export type PaginationLinkProps = _PaginationLinkProps;
    